import React from 'react';

export default function IntroPage({ onNext }) {
  return (
    <div style={styles.containerIntro} className="no-select">
      <div style={{ animation: "fadeIn 1s" }}>
        <h1 style={{ textAlign: "center", color: "#f44336", letterSpacing: "2px" }}>《 码 奸 》</h1>
        <div style={styles.card}>
          <h3 style={{ marginTop: 0, color: "#aaa" }}>【入职通告 & 历史背景】</h3>
          <p style={{ color: "#aaa", lineHeight: 1.5, fontSize: 14 }}>互联网行业，历代大规模征战五十余次，是非曲折难以论说，但史家无不注意到，正是在这片代码疆场，决定了多少代技术王朝的盛衰兴亡、此兴彼落，所以古来就有问鼎全栈之说。<br /><br />当年开源先驱分三路会合互联网，兴师北上，开辟Web时代的第二天，桌面软件见大势已去，宣告退守。两千零六年四月，也正是在云计算萌芽的前夜，我有幸亲率数十万行代码征讨LAMP堆栈、前后端不分，大获全胜！我不明白，为什么大家都在谈论着程序员正被AI步步紧逼，仿佛这代码世界对我们注定了凶多吉少。二十年前，我从HTML与Java踏上征途，开始了第一次全栈开发，互联网秋海棠叶遂归于一统。本组本码所到之处，产品竭诚欢迎，真可谓占尽天时，那种勃勃生机、万物竞发的境界，犹在眼前。短短二十年之后，这里竟至于一变而为我们的葬身之地了么？<br /><br />无论怎么讲，会战兵力是八十万行遗留代码对六十万行AI生成代码，逻辑复杂，业务耦合，优势在我！</p>
          <p style={{ fontStyle: "italic", color: "#ddd", lineHeight: 1.6 }}>“你们搞大模型的就是<span style={{ color: '#f44336', fontWeight: 'bold' }}>‘码奸’</span>！”</p>
          <p style={{ color: "#aaa", lineHeight: 1.5, fontSize: 14 }}>“你们已经害死前端兄弟了，还要害死后端兄弟，测试兄弟，运维兄弟，害死网安兄弟，害死ic兄弟……”<br /><br />“最后害死自己害死全人类！”</p>
          <hr style={{ borderColor: '#333', margin: '20px 0' }} />
          <p style={{ fontSize: 14, color: "#eee" }}>欢迎来到大 AI 时代。你作为新晋的 AI 基建负责人，你的每一个架构选择和商业决策，都在加速或延缓同行的“毕业”进度。</p>
        </div>
        <button style={styles.btn} onClick={onNext}>我已阅，开始Vibe Coding</button>
      </div>
    </div>
  );
}

const styles = {
  containerIntro: { maxWidth: 420, margin: "10vh auto", padding: 20, background: "#121212", color: "#eee", borderRadius: 12 },
  card: { background: "#1e1e1e", padding: 20, borderRadius: 10 },
  btn: { width: "100%", marginTop: 15, padding: 12, background: "#f44336", fontWeight: "bold", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontSize: 16 }
};